/**
 * React dependencies
 */
import PropTypes from 'prop-types';
import { Controller } from "react-hook-form";

/**
 * A react-hook-form controlled hidden text input
 * 
 * @param {Object} props - Component properties (see PropTypes)
 */
 const HiddenTextfield = ({
  id,
  name,
  control,
  defaultValue,
  validation,
}) => {
  return (
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue}
      rules={validation}
      render={({
        field,
      }) => (
        <input
          {...field}
          type='hidden'
          value={field.value ?? defaultValue}
          name={name}
          id={id}
          />
      )}
    />
  );
}

export const HiddenTextfieldProps = {
  id: PropTypes.string,
  name: PropTypes.string,
  control: PropTypes.object,
  defaultValue: PropTypes.string,
  validation: PropTypes.object,
};

export const HiddenTextfieldDefaults = {
  id: '',
  name: '',
  control: null,
  defaultValue: '',
  validation: null,
};

HiddenTextfield.propTypes = HiddenTextfieldProps;
HiddenTextfield.defaultProps = HiddenTextfieldDefaults;

export default HiddenTextfield;
